var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsermanagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.56733C9.65812 7.56733 11.25 5.96305 11.25 3.78366C11.25 1.60427 9.65812 0 7.5 0C5.34375 0 3.75 1.60427 3.75 3.78366C3.75 5.96305 5.34375 7.56733 7.5 7.56733ZM7.5 9.45916C3.35812 9.45916 0 12.5088 0 16.2698V17H15V16.2698C15 12.5088 11.6419 9.45916 7.5 9.45916Z",
    fill: "#5282F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsermanagement);
export default __webpack_public_path__ + "static/media/usermanagement.52960cc49310101778f003203f55d7a0.svg";
export { ForwardRef as ReactComponent };